import DialogPopup from "../components/DialogPopup";
import {Button, Grid, Typography} from "@material-ui/core";
import translate from "../i18n/Translator";
import {RequestCancellationParams} from "../model/CfdisNonIntegrated";
import ValidatedInput from "../components/ValidatedInput";
import {WarningSnackbar} from "../components/Snackbars";
import React, {useState} from "react";


interface CancellationRequestPopupParams {
    onClose(): any;
    open: boolean;
    providerName?: string;
    params: RequestCancellationParams;
    serieFolio?: string;
    doAction(params: RequestCancellationParams): any;
}

export default function CancellationRequestPopup(props: CancellationRequestPopupParams) {
    const [reason, setReason] = useState<string>("");
    const [disabled, setDisabled] = useState<boolean>(true);
    const [warning, setWarning] = useState<string>();
    const onSubmit = () => {
        if (!reason || reason.length <= 0) {
            setWarning(translate("cfdis.cfdis_non_integrated.modals.cancellation_request.error_empty_reason") as string);
            return;
        }
        props.params.reason = reason;
        props.doAction(props.params);
    };

    const onChange = (name: string, value:string) => {
        setReason(value);
        setDisabled(value.length <= 0);
    }

    const getTitle = (elements: number, providerName: string | undefined, serieFolio: string) => {
        switch (elements){
            case 0:
                return translate("cfdis.cfdis_non_integrated.modals.cancellation_request.title_all",
                    {"providerName": providerName}) as string;
            case 1:
                return translate("cfdis.cfdis_non_integrated.modals.cancellation_request.title_single",
                    {"seriesFolio" : serieFolio, "providerName": providerName}) as string;
            default:
                return translate("cfdis.cfdis_non_integrated.modals.cancellation_request.title_selected",
                    {"count" : elements}) as string;
        }
    }

    const onClosedSnackbar = () => {
        setWarning(undefined);
    };

    return (
        <DialogPopup
            open={props.open}
            button={
                <Button onClick={onSubmit} variant="contained" color="primary" size="medium" disabled={disabled}>
                    {translate("cfdis.cfdis_non_integrated.actions.request_cancellation") as string}
                </Button>}
            title={getTitle(props.params.ids.length, props.providerName, props.serieFolio || "")}
            disableEscapeKeyDown={false}
            disableBackdropClick={false}
            closeText={translate("buttons.cancel") as string}
            onClose={props.onClose}
            closeColor="default">
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="body2" paragraph>
                        {translate("cfdis.cfdis_non_integrated.modals.cancellation_request.reason_label") as string}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <ValidatedInput
                        type="text" id="comment" name="comment"
                        label={translate("cfdis.cfdis_non_integrated.modals.cancellation_request.reason_placeholder") as string}
                        value={reason}
                        rows={5}
                        maxLength={500}
                        required={true}
                        disabled={false}
                        margin={"dense"}
                        onValueChanged={onChange}/>
                </Grid>
            </Grid>
            <WarningSnackbar message={warning} onClose={onClosedSnackbar} />
        </DialogPopup>
    );
}